export default "__VITE_ASSET__BzJX6BlZ__"